function zumWarenkorb() {
  const hersteller = document.getElementById('hersteller')?.value;
  if (!hersteller || !window.productId) {
    alert("Bitte einen Hersteller wählen.");
    return;
  }

  const formData = new FormData();
  formData.append("id", window.productId);
  formData.append("properties[Hersteller]", hersteller);

  fetch('/cart/add', {
    method: 'POST',
    body: formData
  })
    .then(res => res.text())
    .then(() => {
      alert("Produkt wurde in den Warenkorb gelegt!");
      window.location.href = "/cart";
    })
    .catch(() => {
      alert("Fehler beim Hinzufügen zum Warenkorb.");
    });
}


function zumWarenkorb() {
  const hersteller = document.getElementById('hersteller')?.value;
  const quantity = parseInt(document.getElementById('quantity')?.value || '1');
  const variantId = window.productId;

  if (!hersteller || !variantId || quantity < 1) {
    alert("Bitte Hersteller und Menge korrekt angeben.");
    return;
  }

  const formData = new FormData();
  formData.append("id", variantId);
  formData.append("quantity", quantity); // ✅ hier!
  formData.append("properties[Hersteller]", hersteller);

  fetch('/cart/add', {
    method: 'POST',
    body: formData
  })
    .then(res => res.text())
    .then(() => {
      alert("Produkt(e) wurden dem Warenkorb hinzugefügt!");
      window.location.href = "/cart";
    })
    .catch(() => alert("Fehler beim Hinzufügen zum Warenkorb."));
}
